import { post, get } from '../../../assets/js/axios';

// eslint-disable-next-line
export const getOrderDetail = params => post('/data/api/query', { ...params }).then(res => res.data);
// export const getOrderDetail = params => axios.post('http://10.188.40.110:8118/data/api/query', { params }).then(res => res.data);

// 司机轨迹
export const fetchDrivingTracks = params => get('/escort/website/track', params).then(res => res.data);

// 路线途经点
export const fetchRouteNodes = params => get('/escort/website/node-list', params).then(res => res.data);

// 司机执行轨迹日志卡片
export const fetchDrivingLogsCard = params => get('/escort/website/operation-card', params).then(res => res.data);
// 查询为运单还是城配任务 1城配任务 2转运运单
export const checkOrderType = params => get('/escort/website/check/waybill', params).then(res => res.data);
// 获取司机最新位置
export const fetchDriverCurPosition = params => get('/escort/website/last-position', params).then(res => res.data);
// 获取task任务状态
export const fetchTaskState = params => get('/escort/website/task/state', params).then(res => res.data);
